import { __assign, __extends, __spreadArray } from "tslib";
import React from 'react';
import { View } from 'react-native';
import { PnmacText, PnmacRow, PnmacTable, PnmacCheckBox } from 'pnmac-universal-components';
import { currencyFormatter } from '../../utils.js';
import { textStyle } from '../../v2/theme';
import moment from 'moment';
import styles from '../../styles/styles.js';
var Delinquent = /** @class */function (_super) {
  __extends(Delinquent, _super);
  function Delinquent(props) {
    return _super.call(this, props) || this;
  }
  Delinquent.prototype.render = function () {
    var _a;
    var _b = this.props,
      translations = _b.translations,
      payment = _b.payment,
      setState = _b.setState,
      delinquentPayments = _b.delinquentPayments,
      layout = _b.layout,
      edit = _b.edit;
    return /*#__PURE__*/React.createElement(PnmacTable, {
      style: {
        marginTop: 15,
        backgroundColor: "#FFFFFF",
        borderRadius: 10,
        marginHorizontal: -10
      },
      borderStyle: {
        borderWidth: 0
      }
    }, /*#__PURE__*/React.createElement(PnmacRow, {
      flexArr: [1, 1, 1],
      data: [/*#__PURE__*/React.createElement(PnmacText, {
        idTag1: 'lblDueDate',
        style: textStyle.defaultTextTitle
      }, translations.DueDate), /*#__PURE__*/React.createElement(PnmacText, {
        idTag1: 'lblAmountDue',
        style: textStyle.defaultTextTitle
      }, translations.AmountDue), /*#__PURE__*/React.createElement(PnmacText, {
        idTag1: 'lblInclude',
        style: textStyle.defaultTextTitle
      }, translations.Include)],
      noBorder: true,
      style: __assign({
        height: "auto",
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        padding: 10
      }, textStyle.formLineWeight)
    }), (_a = __spreadArray(__spreadArray([], delinquentPayments.map(function (f, i) {
      var _a, _b, _c;
      return [/*#__PURE__*/React.createElement(View, {
        style: __assign(__assign({}, styles.oneTimePayment.tableCell), {
          height: layout.mobile ? "auto" : "100%"
        })
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody,
        idTag1: 'lblDeliquentPaymentDueDate'
      }, moment(f === null || f === void 0 ? void 0 : f.dueDate).format("MM/DD/YYYY"))), /*#__PURE__*/React.createElement(View, {
        style: __assign(__assign({}, styles.oneTimePayment.tableCell), {
          height: layout.mobile ? "auto" : "100%"
        })
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody,
        idTag1: 'lblDeliquentPaymentAmount'
      }, currencyFormatter('en-US', 'currency', 'USD', f === null || f === void 0 ? void 0 : f.paymentAmount))), /*#__PURE__*/React.createElement(View, {
        style: __assign(__assign({}, styles.oneTimePayment.tableCell), {
          height: layout.mobile ? "auto" : "100%"
        }),
        align: "left"
      }, f.mandatory && (f.status == 'Pending' ?
      /*#__PURE__*/
      //As per discussion with roshan as prnding required in edit mode
      // {(f.mandatory && (f.paid && !(edit && moment(payment.effectiveDate).date() == moment(f.scheduledDate).date()) ?
      React.createElement(PnmacText, {
        idTag1: 'lblPending',
        style: __assign(__assign({}, textStyle.formBody), {
          fontStyle: "italic"
        })
      }, translations.Pending) : /*#__PURE__*/React.createElement(PnmacText, {
        idTag1: 'lblRequired',
        style: __assign(__assign({}, textStyle.formBody), {
          fontStyle: "italic"
        })
      }, translations.Required)
      // ))}
      ), !f.mandatory && !f.paid ? /*#__PURE__*/React.createElement(View, {
        style: __assign(__assign({}, styles.oneTimePayment.tableCell), {
          display: "flex",
          flexDirection: "row"
        })
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          height: 10,
          width: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, translations.Asterisk)), /*#__PURE__*/React.createElement(View, {
        style: {
          height: "auto",
          width: "auto"
        }
      }, /*#__PURE__*/React.createElement(PnmacCheckBox, {
        idTag1: 'chkDeliquentPayment',
        disabled: !((_a = delinquentPayments === null || delinquentPayments === void 0 ? void 0 : delinquentPayments[i - 1]) === null || _a === void 0 ? void 0 : _a.selected) && ((_b = delinquentPayments === null || delinquentPayments === void 0 ? void 0 : delinquentPayments[i - 1]) === null || _b === void 0 ? void 0 : _b.status) != "Pending" || ((_c = delinquentPayments === null || delinquentPayments === void 0 ? void 0 : delinquentPayments[i - 1]) === null || _c === void 0 ? void 0 : _c.status) == "Pending" && i + 1 == (delinquentPayments === null || delinquentPayments === void 0 ? void 0 : delinquentPayments.length) || edit,
        status: delinquentPayments[i].selected ? 'checked' : 'unchecked',
        onPress: function () {
          if (delinquentPayments[i].selected) {
            delinquentPayments[i].selected = false;
            for (var j = i + 1; j < delinquentPayments.length; j++) {
              delinquentPayments[j].selected = false;
            }
            setState({
              deliquentPayment: false,
              payment: __assign(__assign({}, payment), {
                delinquentPayments: delinquentPayments
              })
            });
          } else {
            delinquentPayments[i].selected = true;
            setState({
              deliquentPayment: true,
              payment: __assign(__assign({}, payment), {
                delinquentPayments: delinquentPayments
              })
            });
          }
        }
      }))) : !f.mandatory && f.paid && /*#__PURE__*/React.createElement(PnmacText, {
        idTag1: 'lblPending',
        style: __assign(__assign({}, textStyle.formBody), {
          fontStyle: "italic"
        })
      }, translations.Pending))];
    }), true), [[/*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({}, styles.oneTimePayment.tableCell), {
        borderBottomLeftRadius: 10,
        height: layout.mobile ? "auto" : "100%"
      })
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody,
      idTag1: 'lblCheckTheBoxToInclude'
    }, translations.CheckTheBoxToInclude)), /*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({}, styles.oneTimePayment.tableCell), {
        height: layout.mobile ? "auto" : "100%"
      })
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody,
      idTag1: 'lblAdditionalFeesWarningMessage'
    }, translations.AdditionalFeesWarningMessage)), /*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({}, styles.oneTimePayment.tableCell), {
        borderBottomRightRadius: 10
      })
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody,
      idTag1: 'lblCannotMakePaymentMessage'
    }, translations.CannotMakePaymentMessage))]], false)) === null || _a === void 0 ? void 0 : _a.map(function (d, i) {
      return /*#__PURE__*/React.createElement(PnmacRow, {
        key: i,
        flexArr: [1, 1, 1],
        data: d
      });
    }));
  };
  return Delinquent;
}(React.Component);
export default Delinquent;